module.exports = __webpack_public_path__ + "b5c780f8aad5ddc4dd143a765a468deb.jpg";